module.exports = __webpack_public_path__ + "img/trailer_front_left.1155c185.png";